import React from 'react';
import { CondensedMedium, Flashy, Gutter, Well } from '@axiom/ui';
import { PasswordStrengthUtil } from '@axiom/utils';

import { StrengthBlock, StrengthMeter } from './PasswordStrengthMeterStyles';

export const scoreLabels = [
  'Very Weak',
  'Weak',
  'Fair',
  'Strong',
  'Very Strong',
] as const;

export type PasswordStrengthMeterProps = {
  password?: string | null;
  name?: string;
};

export const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({
  password,
  name = 'PASSWORD_STRENGTH_METER',
}) => {
  const { score, suggestions } = PasswordStrengthUtil.getPasswordInformation(
    password || ''
  );
  const label = scoreLabels[score];

  return (
    <div data-test={name}>
      <Gutter bottom="8px">
        <StrengthMeter>
          <StrengthBlock
            data-test="block-0"
            full={!!password && score >= 0}
            score={score}
          />
          <StrengthBlock data-test="block-1" full={score >= 1} score={score} />
          <StrengthBlock data-test="block-2" full={score >= 2} score={score} />
          <StrengthBlock data-test="block-3" full={score >= 3} score={score} />
          <StrengthBlock data-test="block-4" full={score >= 4} score={score} />
        </StrengthMeter>
      </Gutter>
      <CondensedMedium className="text-align-center" name="strength-label">
        <Flashy color="textSubtle">Strength: {!!password && label}</Flashy>
      </CondensedMedium>
      {password && score < 3 && suggestions.length > 0 ? (
        <Gutter top="16px">
          <Well background="light blue">
            <CondensedMedium name="password-tips">
              Tips:{' '}
              {!!password &&
                suggestions
                  .join('. ')
                  .replace('..', '.')
                  .trim()
                  .replace(/\.$/, '')}
              .
            </CondensedMedium>
          </Well>
        </Gutter>
      ) : null}
    </div>
  );
};
